import { FETCH_MONITORED_DOCUMENT_MARKDOWN } from '../actions/MonitoredDocumentActions';

// INITIALIZE STATE
const initialState = {
    markdown: null,
    fetching: false,
    fetched: false,
    failed: false,
};

// REDUCER
export const MonitoredDocumentMarkdownReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MONITORED_DOCUMENT_MARKDOWN}_PENDING`:
            return {
                ...state,
                markdown: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_MARKDOWN}_FULFILLED`:
            return {
                ...state,
                markdown: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_MARKDOWN}_REJECTED`:
            return {
                ...state,
                markdown: null,
                fetching: false,
                fetched: false,
                failed: true,
            };
        default:
            return state;
    }
};
